import { useMutation } from "@tanstack/react-query";
import { saveBrevoMappings } from "../../api/bBrevoApi";

export const useSaveBrevoMappings = () => {
  return useMutation({
    mutationKey: ["save-brevo-mappings"],
    mutationFn: (data) => saveBrevoMappings(data),
    onError: (error) => {
      console.error("Brevo mapping save error:", error.response || error);
    },
  });
};
